export const getTaskListSearch = state => state.userInterface.taskListSearch;
export const getSelectedAccount = state => state.userInterface.selectedAccount;
export const getOpenHamburgerMenu = state =>
  state.userInterface.openHamburgerMenu;
export const getShowHeaderPerPage = state =>
  state.userInterface.showHeaderPerPage;
export const getConfirmAlert = state => state.userInterface.confirmAlert;
